import {removeAlphabetsFromString} from "./string.utils";

/**
 * Remove Alpha Characters from data.
 * @param {string} str - The string to check.
 * @returns {number|null} - Returns the string.
 */
export function convertStringToFloat (str) {
    if (typeof str === "string") {

        let data =  removeAlphabetsFromString(str);

        if(data && !isNaN(data)) {
            return parseFloat(data);
        }
    }
    return null;
}

/**
 * ParseStrToFloat
 * @param {string} str - The string to check.
 * @returns {number|null} - Returns the string.
 */
export function safeParseFloat (str) {
    const parsed = parseFloat(removeAlphabetsFromString(str));
    return isNaN(parsed) ? 0 : parsed;
}